import { colorSet } from '@components/Provider';
import { makeStyles } from '@material-ui/core';

const useStyles = makeStyles((theme) => ({
  'Chat-Common-Bubble-root': {
    padding: '0px 16px',
    '& .primary-text': {
      fontWeight: 500,
      color: colorSet.primary500
    },
    '& .message-container': {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center'
    },
    '& .message-divider': {
      width: '100%',
      backgroundColor: colorSet.gray400,
      margin: '40px 0px'
    },
    '& .checkCircleIcon': {
      color: colorSet.primary500,
      marginBottom: 8
    }
  }
}));

export default useStyles;
